.banner-review-block {
  @apply bg-clrs-kbb-airforceblue;
  @apply flex;
  @apply border-clrs-kbb-gold;
  @apply border-solid;
  @apply border-2;
  @apply rounded;
  @apply justify-between;
  @apply text-clrs-white;
  @apply font-open-sans;
  @apply px-5;
}

.banner-review-title {
  @apply font-extrabold;
  @apply text-clrs-white;
  @apply text-2.5xl/6;
  @apply mb-0;
}
